module.exports = __webpack_public_path__ + "img/empty_icon.a0ba74cf.png";